// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1Pb7g","consentsList":"PatientConsents_consentsList__26mei","consentsListEmpty":"PatientConsents_consentsListEmpty__20xLy"};